// extracted by mini-css-extract-plugin
export var compactFilters = "_go-4";
export var detailImage = "_go-1";
export var dropdownContainer = "_go-2";
export var imageContainer = "_go-0";
export var selectedCard = "_go-3";